export interface IExpertSystemOrder {
    id: number,
    expertSystemId: number,
    donorId: number,
    recipientId: number,
    donorAlias: string,
    recipientAlias: string,
    statusId: number,
    ordersSent: string,
    donorResultsReceived: string,
    recpResultsReceived: string,
    recomendation: string,
    alertSent: string,
    alertAcknowledged: string,
    comments: string,
    recipientTyping: boolean,
    donorTyping: boolean
}